import React from 'react';

import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';

const StripeCustomerIdField = () => {
  const { canModifyBillingId } = useSession();
  if (!canModifyBillingId) {
    return false;
  }
  return <FormField name="stripeCustomerId" xs={4} type="string" mode="dark" label="Billing ID" />;
};

export default StripeCustomerIdField;
